/* Welche Vorschau passt zu einer Datei? Aus dem Speicherpfad bzw. Dateinamen
 * abgeleitet — der Dateiname wird nur hierfür gelesen, nie angezeigt.
 */

const IMAGE_EXT = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'avif'];

/** 'pdf' | 'image' | 'other' */
export function fileKind(file) {
  if (!file) return 'other';
  const raw = String(file.path || file.filename || file.name || '');
  const ext = raw.split('?')[0].split('.').pop().toLowerCase();
  if (ext === 'pdf') return 'pdf';
  if (IMAGE_EXT.includes(ext)) return 'image';
  // Altbestand mit eingebetteten Daten (data:-Adresse) hat keinen Pfad.
  const inline = String(file.data || file.url || '');
  if (inline.startsWith('data:application/pdf')) return 'pdf';
  if (inline.startsWith('data:image/')) return 'image';
  return 'other';
}
